import NavbarLoggedOutProfile from "@/components/NavBar/NavbarLoggedOutProfile";
import NavButton from "@/components/NavBar/NavButton";
import SideDrawer from "@/components/NavBar/SideDrawer";
import {useHelpUrl} from "@/hooks/useNavigationHooks";
import {type FC, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useMedia, useToggle} from "react-use";

const NavbarLoggedOut: FC = () => {
  const {t} = useTranslation("navigation");
  const helpUrl = useHelpUrl();
  const isMobileView = useMedia("(max-width: 1024px)");
  const [isDrawerOpen, toggleDrawerOpen] = useToggle(false);

  const forInfluencersButton = useMemo(
    () => <NavButton pointingToLandingPage to={`/for-influencers/`} text={t("for_influencers")} />,
    [t],
  );

  const forBrandsButton = useMemo(() => <NavButton pointingToLandingPage to="/?landing" text={t("for_brands")} />, [t]);

  const helpButton = useMemo(() => <NavButton pointingToLandingPage to={helpUrl} text={t("help")} />, [t, helpUrl]);

  const aboutUsButton = useMemo(() => <NavButton pointingToLandingPage to={`/about/`} text={t("about_us")} />, [t]);

  return isMobileView ? (
    <SideDrawer isOpen={isDrawerOpen} toggleOpen={toggleDrawerOpen}>
      <NavButton text={t("login")} to="/login/" />
      <NavButton text={t("register")} to="/register/" />
      <div className="bg-neutral-grey-light h-[1px] w-full" />

      {forInfluencersButton}
      {forBrandsButton}
      {helpButton}
      {aboutUsButton}
    </SideDrawer>
  ) : (
    <div className="flex h-full items-center gap-10">
      {forInfluencersButton}
      {forBrandsButton}
      {helpButton}
      {aboutUsButton}
      <NavbarLoggedOutProfile />
    </div>
  );
};

export default NavbarLoggedOut;
